export const environment = {
  baseUrl: 'https://folio.total-poc.aodocs.app/',
  apiUrl: 'api/',
  clientId: '995780531230-jv3ta52lv9jekqa5o84l0ubs92tcp0ra.apps.googleusercontent.com',
  aodocsUrl: 'https://total.success.aodocs.app/',
  version: '4.2.0',
  production: false,
  firebase: {
    apiKey: "AIzaSyCjnVrp9BFZ1SaKSEiROH_XenLez0K0sF8",
    authDomain: "aodocs-total-poc-euw3.firebaseapp.com",
    databaseURL: "https://aodocs-total-poc-euw3.firebaseio.com",
    projectId: "aodocs-total-poc-euw3",
    storageBucket: "aodocs-total-poc-euw3.firebasestorage.app",
    messagingSenderId: "1059879503458",
    appId: "1:1059879503458:web:8e5bc3808bbdfb11c9333b",
    measurementId: ""
  }
};
